import { useTheme } from "../contexts/ThemeContext";
import { themeColors } from "../config/theme";
import type { ThemeColors } from "../config/theme";

/** Theme colours for canvas, Chart.js, MapLibre and deck.gl, which can't read CSS classes. */
export function useThemeColors(): ThemeColors {
  const { isDark } = useTheme();
  return themeColors(isDark);
}
